import { useHttpsCallable } from "react-firebase-hooks/functions";
import { functions } from "@poseidon/firebase/firebase";

export const useUpdateBaseRate = () => {
  const [executeCallable, saving, error] = useHttpsCallable(
    functions,
    "updateBaseRate"
  );
  const updateBaseRate = async (rate) => {
    const result = await executeCallable({ rate });
    return result?.data;
  };
  return { saving, error, updateBaseRate };
};
